<template>
  <div class="w-[380px]">
    <div class="flex items-start space-x-3">
      <p
        class="rounded px-2 py-1 text-xs font-semibold"
        :class="
          account != 'DEMO'
            ? 'bg-ontick-blue-900 text-ontick-blue-500'
            : 'bg-gray-500 text-gray-200'
        "
      >
        {{ account == "PRD" ? "PROD" : "DEMO" }}
      </p>
      <div>
        <div class="flex items-center space-x-2">
          <div class="h-8 w-8" v-html="icons" />
          <h2 class="font-semibold text-ontick-carbon-900 dark:text-gray-200">
            {{ id }}
          </h2>
        </div>
        <h1
          class="text-sm font-medium text-ontick-carbon-900 dark:text-gray-200"
        >
          {{ title }}
        </h1>
        <p class="mt-1 truncate text-xs text-gray-400">
          {{ message }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["account", "message", "title", "id", "icons"],
};
</script>
<style>
/* .container {
  width: 19rem !important;
} */
</style>
